import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=be6a6b44&scoped=true&"
import script from "./CardTable.vue?vue&type=script&lang=js&"
export * from "./CardTable.vue?vue&type=script&lang=js&"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=be6a6b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a6b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
